<template>
  <div>
    <v-form class="py-4 layout align-end statisticsTemplates">
      <v-flex xl2 md4 mr-2>
        <v-select
          v-model="curTemplate"
          :items="$store.getters.templateList"
          @change="changeTemplate"
          height="32"
          item-text="name"
          return-object
          class="content-bg--1 v-text-field--noBorder"
          hide-details
          dense
          solo
        >
          <template v-slot:selection="{ item }">
            <div class="ellipsis">{{ item.name }}</div>
          </template>
        </v-select>
      </v-flex>
      <v-flex xl2 md2 mr-2>
        <v-btn
          v-if="$store.getters.templateList.length !== 0"
          @click="editTemplate"
          icon
          class="flex-none my-0 mr-0"
        >
          <icon-pencil></icon-pencil>
        </v-btn>
        <v-btn
          v-if="$store.getters.templateList.length !== 0"
          @click="deleteTemplate"
          icon
          class="flex-none my-0 ml-0"
        >
          <icon-close></icon-close>
        </v-btn>
      </v-flex>
      <download-xlsx-csv
        v-if="
          $store.getters.templateList.length !== 0 &&
            !this.curTemplate.params.switcher
        "
        :param="params"
        :type="type"
        class="flex text-sm-right flex-column align-self-center"
      >
      </download-xlsx-csv>
    </v-form>
    <statistics-visits
      v-if="type === 'statisticsVisits'"
      :filter-params="params"
      :hotspotName="params.hotspotName"
      :hotspot_id="params.hotspot_id"
      @editSmsDialog="editSmsDialog"
      @setFilter="setFilter"
      ref="statistics"
    >
    </statistics-visits>
    <statistics-general-main
      v-if="type === 'statisticsGeneral'"
      :filter-params="params"
      @setFilter="setFilter"
      @editSmsDialog="editSmsDialog"
      ref="statistics"
    ></statistics-general-main>
    <statistics-gone
      v-if="type === 'statisticsGone'"
      :filter-params="params"
      :hotspotName="params.hotspotName"
      :hotspot_id="params.hotspot_id"
      @setFilter="setFilter"
      @editSmsDialog="editSmsDialog"
      ref="statistics"
    ></statistics-gone>
  </div>
</template>
<script>
import StatisticsVisits from "./StatisticsVisits.vue";
import StatisticsGeneralMain from "./StatisticsGeneralMain.vue";
import StatisticsGone from "./StatisticsGone.vue";
import IconPencil from "../icon/IconPencil.vue";
import IconClose from "../icon/IconClose.vue";
import DownloadXlsxCsv from "../common/DownloadXlsxCsv";

export default {
  name: "StatisticsTemplates",

  components: {
    StatisticsVisits,
    StatisticsGeneralMain,
    StatisticsGone,
    IconPencil,
    IconClose,
    DownloadXlsxCsv
  },

  data: () => ({
    //ошибка
    error: "",
    // тип статистики текущего шаблона
    curType: "",
    // текущий выбранный шалон в списке
    curTemplate: { params: { type: "" } }
  }),
  props: {
    // текущий шаблон
    template: {
      default: function() {
        return { params: { type: "" } };
      }
    }
  },
  computed: {
    //тип графика
    type() {
      return this.curTemplate ? this.curTemplate.params.type : "";
    },
    // параметры для графика
    params() {
      const has = Object.prototype.hasOwnProperty;
      if (!this.curTemplate) return {};
      else if (
        this.curTemplate.params &&
        has.call(this.curTemplate.params, "switcher")
      ) {
        return this.curTemplate.params.switcher
          ? this.curTemplate.params
          : { ...this.curTemplate.params.params };
      } else {
        return this.curTemplate.params;
      }
    }
  },
  mounted() {
    // заполняем список шаблонов
    this.$store.dispatch("templateListLoad").then(() => {
      if (this.$store.getters.templateList.length === 0) {
        this.$emit("setFilter", {});
      }
      if (!this.template) this.template = {};
      if (!this.template.id) this.changeTemplate(this.$store.getters.template);
      else this.changeTemplate(this.template);
    });
  },
  methods: {
    /**
     * Выбираем конкретный шаблон и запускаем фильтрацию
     */
    changeTemplate(item) {
      this.curTemplate = item;
      if (!item) return false;
      try {
        if (this.curType === item.params.type)
          this.$refs.statistics.filterItems(this.curTemplate.params);
        this.curType = item.params.type;
      } catch (e) {
        this.error = e;
      }
    },
    /**
     * Изменение названия шаблона
     */
    editTemplate() {
      if (!this.curTemplate) return false;
      this.$emit("editTemplateDialog", {
        template: this.curTemplate,
        editName: true
      });
    },
    /**
     * Удаление шаблона
     */
    deleteTemplate() {
      if (!this.curTemplate) return false;
      this.$store
        .dispatch("deleteTemplate", { id: this.curTemplate.id })
        .then(() => {
          // открываем сообщение
          this.$store.dispatch("popupInfoOpen", {
            text: "Шаблон успешно удален"
          });
          this.changeTemplate(this.$store.getters.template);
        });
    },
    /**
     * Фильтрация данных
     */
    setFilter(params) {
      this.$emit("setFilter", {
        id: this.curTemplate.id,
        name: this.curTemplate.name,
        params: params
      });
    },
    /**
     * Диалоговое окно отправки смс
     */
    editSmsDialog(params) {
      this.$emit("editSmsDialog", params);
    }
  }
};
</script>
